import { accessGuard } from '@aspectus/vue-router-permissions'
import createInitialRoutes from '@/router/routes'

export type optionsT = { app: any, createInstance: any, createWebHistory: any, pinia: any }

export function createRoutes(options: optionsT): any[] {
  return [
    ...createInitialRoutes(options),
  ]
}

function waitForPageLoad(): Promise<void> {
  return new Promise(resolve => {
    if (document.readyState === 'complete') {
      resolve()
    } else {
      window.addEventListener('load', () => resolve(), { once: true })
    }
  })
}

export function scrollBehavior(
  to: { hash: string },
  from: unknown,
  savedPosition: { left?: number, top?: number } | null
): any {
  if (savedPosition) {
    return savedPosition
  }

  if (to.hash) {
    return waitForPageLoad().then(() => ({ el: to.hash }))
  }

  return {
    top: window.pageYOffset,
    left: window.pageXOffset,
  }
}

export default function createRouter(options: optionsT): any {
  const { createInstance, createWebHistory } = options
  const router = createInstance({
    history: createWebHistory(),
    scrollBehavior,
    routes: createRoutes(options),
  })

  router.beforeEach(accessGuard(options))

  return router
}
